import { angieRoutePrefix } from 'src/app/globals';

const CSDD_API_SEGEMENT = 'custom_session_data_definitions';
const CSDD_API_BASE_URL = angieRoutePrefix.concat(`/${CSDD_API_SEGEMENT}`);

export class CustomSessionDataDefinitionsApiConfig {
	public static readonly CUSTOM_SESSION_DATA_DEFINITIONS_BASE_URL = `${CSDD_API_BASE_URL}.json`;
	public static readonly DELETE = (csddId: number): string => `${CSDD_API_BASE_URL}/${csddId}.json`;
	public static readonly UPDATE = (csddId: number): string => `${CSDD_API_BASE_URL}/${csddId}.json`;
	public static readonly SHOW = (csddId: number): string => `${CSDD_API_BASE_URL}/${csddId}.json`;
}
